exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".advantages .advantages-heading h2 {\r\n  color: #84baac;\r\n}\r\n\r\n.advantages .advantages-contents {\r\n  height: 200px;\r\n}\r\n\r\n.advantages .advantages-contents p{\r\n  margin-bottom: 0;\r\n}\r\n\r\n.advantage img {\r\n  width: 150px;\r\n  height: 150px;\r\n}\r\n\r\n.advantage-left .advantage-content {\r\n  margin: auto 5px auto 0;\r\n  font-size: .85rem;\r\n}\r\n\r\n.advantage-right .advantage-content {\r\n  margin: auto 0 auto 5px;\r\n  font-size: .85rem;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .advantage-right {\r\n    padding-top: 5rem;\r\n  }\r\n}\r\n\r\n.advantages a, .advantages a:link {\r\n  color: #4b525b;\r\n}\r\n\r\n.advantages a:hover {\r\n  color: #85baac;\r\n}\r\n\r\n.advantages a:hover img {\r\n  width: 160px;\r\n  height: 160px;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .advantage img {\r\n    width: 100px;\r\n    height: 100px;\r\n  }\r\n  .advantages a:hover img {\r\n    width: 110px;\r\n    height: 110px;\r\n  }\r\n  .advantages .advantages-contents {\r\n    height: auto;\r\n    padding-bottom: 2rem;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/home/advantage/advantage.component.css
// module id = ../../../../../src/app/components/home/advantage/advantage.component.css
// module chunks = main